// Action types for updating data
export const UPDATE_STORE_REQUEST = 'UPDATE_STORE_REQUEST';
export const UPDATE_STORE_SUCCESS = 'UPDATE_STORE_SUCCESS';
export const UPDATE_STORE_FAILURE = 'UPDATE_STORE_FAILURE';
export const UPDATE_STORE_RESET = 'UPDATE_STORE_RESET';
// Update data actions
export const updateStoreDataRequest = (payload) => ({
    type: UPDATE_STORE_REQUEST,
    payload
});
export const updateStoreDataSuccess = (payload) => ({
    type: UPDATE_STORE_SUCCESS,
    payload,
});
export const updateStoreDataFailure = (error) => ({
    type: UPDATE_STORE_FAILURE,
    payload: error,
});
export const updateStoreDataReset = () => ({
    type: UPDATE_STORE_RESET,
});
